import { useApiPatchRequest } from '@/api/rest/hooks/useApiPatchRequest';
import { useApiPostRequest } from '@/api/rest/hooks/useApiPostRequest';

import {
  JobSubscription,
  PATCH_JOB_SUBSCRIPTION_PATH,
  PatchJobSubscriptionErrorDto,
  PatchJobSubscriptionRequestBodyData,
  PatchJobSubscriptionRequestPathVariables,
  POST_JOB_SUBSCRIPTION_PATH,
  PostJobSubscriptionErrorDto,
  PostJobSubscriptionRequestBodyData,
} from './types/jobSubscriptions';

export const usePostJobSubscription = () => {
  return useApiPostRequest<
    undefined,
    undefined,
    PostJobSubscriptionRequestBodyData,
    JobSubscription,
    PostJobSubscriptionErrorDto
  >(POST_JOB_SUBSCRIPTION_PATH);
};

export const usePatchJobSubscription = () => {
  return useApiPatchRequest<
    PatchJobSubscriptionRequestPathVariables,
    undefined,
    PatchJobSubscriptionRequestBodyData,
    JobSubscription,
    PatchJobSubscriptionErrorDto
  >(PATCH_JOB_SUBSCRIPTION_PATH);
};
